export interface IEntradaInventarioDetalle {
    id: number;
    idDistribuidora: number;
    idProducto: number;
    idContenedor: number;
    capacidadContenedor: number;
    cantidadContenedor: number;
    cantidadSuelta: number;
}
export interface ISalidaInventarioDetalle {
    id: number;
    idDistribuidora: number;
    idProducto: number;
    idContenedor: number;
    capacidadContenedor: number;
    cantidadContenedor: number;
    cantidadSuelta: number;
}

export interface IEntradaInventario {
    id: number;
    distribuidora: string;
    usuario: string;
    observaciones: string;
    motivoCancelacion: string | null;
    tipo_entrada: string;
    estatus: number;
    fecha: string;
    idDistribuidora: number;
    idUsuario: number;
    idTipoEntrada: number;
    fechaCancela: string | null;
    detalles: IEntradaInventarioDetalle[];
}
export interface ISalidaInventario {
    id: number;
    distribuidora: string;
    usuario: string;
    observaciones: string;
    motivoCancelacion: string | null;
    tipo_salida: string;
    estatus: number;
    fecha: string;
    idDistribuidora: number;
    idUsuario: number;
    idTipoSalida: number;
    fechaCancela: string | null;
    detalles: ISalidaInventarioDetalle[];
}
export interface IEntSalInvSearch {
    idDistribuidora: string;
    page: number;
    fecha?: string;
}
export interface IConteoInventario {
    id: number;
    idDistribuidora: number;
    idUsuario: number;
    observaciones: string | null;
    idTipoConteo: number;
    distribuidora: string;
    idHorario: number;
    usuario: string;
    tipo_conteo: string;
    horario: string;
    estatus: number;
    fecha: Date;
    idUsuCancela: number | null;
    motivoCancelacion: string | null;
    fechaCancela: Date | null;
}
export const EntradaInventarioError = {
    observaciones: '',
    idTipoEntrada: '',
    estatus: '',
    motivoCancelacion: '',
};
export const SalidaInventarioError = {
    observaciones: '',
    idTipoSalida: '',
    estatus: '',
    motivoCancelacion: '',
};
export const ConteoInventarioError = {
    observaciones: '',
    idTipoConteo: '',
    estatus: '',
    idHorario: '',
    errorVerificado: '',
    motivoCancelacion: '',
};